export interface Offer {
    id: string
    name: string
    copy: {
        pricingmodal: {
            title: string
            subtitle?: string
            discountBannerText?: string
        }
    }
    showCountdown: boolean
    hasOffer?: string[]
}

export const OFFERS: Record<string, Offer> = {
    default: {
        id: 'default',
        name: 'Default Offer',
        copy: {
            pricingmodal: {
                title: 'Fair pricing that scales\nwith your needs',
                discountBannerText: 'Launch Offer',
            },
        },
        hasOffer: ['2x-credits'],
        showCountdown: false,
    },
    'skip-waitlist': {
        id: 'skip-waitlist',
        name: 'Default Offer',
        copy: {
            pricingmodal: {
                title: 'Pricing that scales with your needs',
                subtitle: '(and up to 10x cheaper than alternatives)',
                discountBannerText: '2x Early Bird Bonus',
            },
        },
        hasOffer: ['2x-credits'],
        showCountdown: false,
    },
    '2x-credits': {
        id: '2x-credits',
        name: 'Default Offer',
        copy: {
            pricingmodal: {
                title: 'Upgrade TODAY for\n 2X more invoices',
                discountBannerText: ' 2X more invoices',
            },
        },
        hasOffer: ['2x-credits'],
        showCountdown: true,
    },
    'no-credits': {
        id: 'no-credits',
        name: 'No Credits Offer',
        copy: {
            pricingmodal: {
                title: 'Get More Credits to Continue Processing',
                discountBannerText: 'Launch Offer',
            },
        },
        showCountdown: true,
    },
    '25-percent-today': {
        id: '25-percent-today',
        name: '25% Today Offer',
        copy: {
            pricingmodal: {
                title: 'Upgrade TODAY for\n 25% more invoices',
            },
        },
        showCountdown: true,
    },
}

export function getOfferById(id: string): Offer | undefined {
    return OFFERS[id]
}
